// extracted by mini-css-extract-plugin
export default {"wrapper":"Options_wrapper__4PRWG","acc-avatar":"Options_acc-avatar__fYCBo","cart":"Options_cart__dh6RK","number-of-products":"Options_number-of-products__uKjXN"};